import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=38b5d5ea&"
import script from "./UserAvatar.vue?vue&type=script&lang=ts&"
export * from "./UserAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports